// extracted by mini-css-extract-plugin
module.exports = {"shopini-logistics":"styles_shopini-logistics__1OGiQ","title":"styles_title__2Zafi","sub-title":"styles_sub-title__2OGcT","btn-overrides":"styles_btn-overrides__32wX7"};